import React from 'react';
import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { PopoverMenuItem } from '../../popover/menu/popover-menu-item.component';
import { PopoverMenu } from '../../popover/menu/popover-menu.component';
import { usePopoverMenu } from '../../popover/menu/use-popover-menu';
import { ActionDropdownChip } from '../atoms/action-dropdown-chip';
import { truncate } from '../common-styles';

const fontPickerActionActionDropdownChipStyle1 = css`
  width: 140px;
`;

const fontPickerActionSpanStyle2 = css`
  color: ${theme.colors.neutral90};
`;

const fontPickerActionPopoverMenuStyle3 = css`
  width: 291px;
`;

const fontPickerActionPopoverMenuItemStyle4 = css`
  & span {
    font-family: var(--font-picker-action--popover-menu-item-inline-value);
  }
`;

type FontPickerActionProps = {
  value?: string;
  onChange: (font: string) => void;
} & Pick<React.ComponentProps<typeof ActionDropdownChip>, 'showBoxShadow' | 'compact' | 'className'>;

export const FontPickerAction = ({
  value = 'DM Sans',
  showBoxShadow = true,
  compact,
  onChange,
  ...rest
}: FontPickerActionProps) => {
  const { getTriggerProps, getMenuProps, getItemProps, isOpen } = usePopoverMenu<HTMLButtonElement | HTMLAnchorElement>(
    {
      interactionOptions: {
        listNavigation: {
          selectedIndex: selectedIndex(value),
        },
      },
      placement: 'bottom-start',
      middlewareOptions: {
        offset: {
          crossAxis: 0,
          mainAxis: 12,
        },
      },
    }
  );

  return (
    <>
      <ActionDropdownChip
        showBoxShadow={showBoxShadow}
        isOpen={isOpen}
        isActive={isOpen}
        compact={compact}
        {...getTriggerProps()}
        {...rest}
        className={cx(rest.className, fontPickerActionActionDropdownChipStyle1)}
      >
        <span className={cx(truncate, fontPickerActionSpanStyle2)}>{value}</span>
      </ActionDropdownChip>
      <PopoverMenu {...getMenuProps()} returnFocus={false} className={fontPickerActionPopoverMenuStyle3}>
        {defaultFonts.map((value, index) => (
          <PopoverMenuItem
            key={value}
            {...getItemProps({
              index,
              onClick: () => onChange(value),
            })}
            className={fontPickerActionPopoverMenuItemStyle4}
            style={
              {
                '--font-picker-action--popover-menu-item-inline-value': value,
              } as any
            }
          >
            {value}
          </PopoverMenuItem>
        ))}
      </PopoverMenu>
    </>
  );
};

const selectedIndex = (selectedFont: string) => {
  const index = defaultFonts.indexOf(selectedFont);
  return index < 0 ? null : index;
};

const defaultFonts = [
  'DM Sans',
  'Arial',
  'Helvetica',
  'Verdana',
  'Tahoma',
  'Trebuchet MS',
  'Georgia',
  'Times New Roman',
  'Courier New',
];
